export default "/_next/static/images/e6d86ba6b1ea3bf18d59873f06b22ea3.png";